import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import UserModel from '@/models/entities/UserModel';
import UserProviderModel from '@/models/entities/UserProviderModel';

/** Identité d'un user dans un IAM externe (GET /iam_identities, admin, lecture seule) ; userProvider réduit à son identité : à résoudre par l'écran (fetchResolvable('userProvider')) pour son nom */
export default class IamIdentityModel extends AbstractApiModel {
  protected _path = '/iam_identities/{?id}';

  @doc.model(() => UserModel) declare user: UserModel;
  @doc.model(() => UserProviderModel) declare userProvider: UserProviderModel;

  /** user : un id, ou plusieurs (user[]=…, ex. les utilisateurs d'une page de liste) */
  declare _tsFilters: { user?: string | string[] };
  declare _tsSorts: { 'userProvider.name'?: unknown };

  @doc.string declare subjectId: string;
  @doc.boolean declare active: boolean;

  get userId(): number {
    return Number(this.user.id) || 0;
  }

  get userProviderName(): string {
    return this.userProvider.name;
  }
}
